import { render } from "./index.vue?vue&type=template&id=bcacfd0c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bcacfd0c&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcacfd0c"],['__file',"src/views/people/levelIcon/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bcacfd0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bcacfd0c', __exports__)) {
    console.log('reload')
    api.reload('bcacfd0c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=bcacfd0c&scoped=true", () => {
    console.log('re-render')
    api.rerender('bcacfd0c', render)
  })

}


export default __exports__